import { useTranslation } from 'react-i18next'
import * as z from 'zod'

export const useCustomError = () => {
  const { t } = useTranslation()

  const customErrorMap: z.ZodErrorMap = (issue, ctx) => {
    // Errore di tipo
    if (issue.code === z.ZodIssueCode.invalid_type) {
      switch (issue.expected) {
        case 'number':
          return { message: t('validation.type_number_error') }
        case 'string':
          return { message: t('validation.type_text_error') }
        case 'date':
          return { message: t('validation.type_date_error') }
        case 'integer':
          return { message: t('validation.type_int_error') }
        case 'float':
          return { message: t('validation.type_decimal_error') }
        case 'boolean':
          return { message: t('validation.type_boolean_error') }
      }
    }

    if (issue.code == z.ZodIssueCode.invalid_enum_value) {
      return { message: t('validation.required_error') }
    }

    // Errore minimo (min, gt, gte)
    if (issue.code === z.ZodIssueCode.too_small) {
      switch (issue.type) {
        case 'number':
          return { message: issue.inclusive ? t('validation.greater_or_equal_error', { min: issue.minimum }) : t('validation.greater_error', { min: issue.minimum }) }
        case 'string': {
          // Errore campo obbligatorio
          if (issue.minimum === 1) return { message: t('validation.required_error') }
          // E
          else return { message: t(`validation.string_min_error`, { min: issue.minimum }) }
        }
      }
    }
    // Errore massimo (max, lt, lte)
    if (issue.code === z.ZodIssueCode.too_big) {
      switch (issue.type) {
        case 'number':
          return { message: issue.inclusive ? t('validation.less_or_equal_error', { max: issue.maximum }) : t('validation.less_error', { max: issue.maximum }) }
        case 'string':
          return { message: t('validation.string_max_error', { max: issue.maximum }) }
      }
    }

    // Errore regex
    if (issue.code === z.ZodIssueCode.invalid_string) {
      if (issue.validation === 'regex') return { message: t('validation.format_error') }
    }

    // Errori di dafault
    return { message: ctx.defaultError }
  }

  return customErrorMap
}
